import {
    Field,
    FormikProps,
} from 'formik';

import {I18n} from '@aws-amplify/core';

import {
    PacFormikInput,
    PacFormikPasswordInput,
    PlatformFieldset
} from "@pac/platform-ui-components";
import {HandoffCredentials} from "../types.ts";

export const FormComponent = (props: FormikProps<HandoffCredentials>) => {

    const values = props.values;

    return (
        <PlatformFieldset legend={I18n.get('Sign In')}>
            <Field
                type="email"
                name="email"
                label={I18n.get('Email')}
                value={values.email}
                placeholder={I18n.get('Email')}
                component={PacFormikInput}
                autoFocus={values.email === ''}
                my={'xl'}
            />
            <Field
                type="password"
                name="password"
                label={I18n.get('Password')}
                placeholder={I18n.get('Password')}
                component={PacFormikPasswordInput}
                autoFocus={values.email !== ''}
                my={'xl'}
            />
        </PlatformFieldset>
    );
};
